var convert = require('./convert'),
    func = convert('memoize', require('../memoize'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/memoize.js
// module id = 2406
// module chunks = 0